module.exports = __webpack_public_path__ + "static/media/music.d4b02a4b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/music.mp3
// module id = 57
// module chunks = 0